import type { BlockFragment } from "@ihr-radioedit/inferno-webapi";
import { isScheduled } from "../../page-blocks/schedule";

const RIGHT_RAIL = ["ad:top", "ad:sponsor", "right:dynamic", "recommendation:right", "cume:right"];
const BOTTOM = ["ad:bottom-leaderboard"];
const TOP = ["main:front-matter", "header:dynamic"];
const DEPRECATED = ["ad:top-leaderboard", "ad:middle-leaderboard", "ad:rail", "ad:mid", "ad:sponsor-byline"];

export interface RegionMap {
  [column: string]: {
    [region: string]: BlockFragment[];
  };
}

const precedesOnairInRegion = (block: BlockFragment, blocks: BlockFragment[], now: number) =>
  block.type === "advertise" &&
  blocks.some(
    other =>
      other.type === "onair" &&
      other.region === block.region &&
      other.ordinal > block.ordinal &&
      isScheduled(now, other.schedule),
  );

const getColumn = (block: BlockFragment, blocks: BlockFragment[], now: number) => {
  if (RIGHT_RAIL.includes(block.region)) {
    return "right";
  } else if (BOTTOM.includes(block.region)) {
    return "bottom";
  } else if (TOP.includes(block.region) || block.type === "onair" || precedesOnairInRegion(block, blocks, now)) {
    return "top";
  } else {
    return "left";
  }
};

// Group blocks
export const createRegionsFromBlocks = (blocks: BlockFragment[], now = Date.now()): RegionMap =>
  blocks
    .filter(block => !DEPRECATED.includes(block.region))
    .reduce((regions: RegionMap, block) => {
      const column = getColumn(block, blocks, now);
      regions[column] = regions[column] || {};
      regions[column][block.region] = regions[column][block.region] || [];
      regions[column][block.region].push(block);
      return regions;
    }, {});
